/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { LightListDetailPopupWrap } from '@styles/base.style'
import { isMobile } from 'react-device-detect'

const BettingRulesDetail: React.FC = () => {
  const { componentStore } = useRootStore()
  const bettingRule = componentStore.selectedBettingRule

  return (
    <LightListDetailPopupWrap className={!isMobile && 'pc'}>
      {bettingRule && (
        <Fragment>
          <div className="list-info row">
            {bettingRule.isNotice === 1 && (<span className="main-tag">주요</span>)}
            <p className="tit">{bettingRule.title}</p>
          </div>
          <div dangerouslySetInnerHTML={{ __html: bettingRule.content }} className="list-contents"/>
        </Fragment>
      )}
    </LightListDetailPopupWrap>
  )
}
export default observer(BettingRulesDetail)
